<template>
  <div class="pv-screen-outer">
    <div class="pv-dashboard">
      <PvHeader :title="screenTitle" :online-sites="headerOnlineSites" />
      <div class="main">
        <PvLeftColumn
          ref="pvLeft"
          :alarms="alarms"
          :cleared-count="clearanceLog.length"
          @alarm-click="showClearance"
          @show-log="openClearanceLog"
          @alarms-loaded="alarms = $event"
          @sites-loaded="onSitesLoaded"
        />

        <PvCenterColumn ref="centerColumn" />

        <PvRightColumn ref="rightColumn" />

        <!-- <PvBottomBar /> -->
      </div>
    </div>

    <PvModals
      :clearance-visible="clearanceModal"
      :log-visible="logModal"
      :current-alarm="currentAlarm"
      :clearance-person.sync="clearancePerson"
      :clearance-note.sync="clearanceNote"
      :clearance-log="clearanceLog"
      @close-clearance="closeClearance"
      @close-log="logModal = false"
      @confirm-clearance="confirmClearance"
    />
  </div>
</template>

<script>
import PvHeader from "./header/PvHeader.vue";
import PvLeftColumn from "./left/PvLeftColumn.vue";
import PvCenterColumn from "./center/PvCenterColumn.vue";
import PvRightColumn from "./right/PvRightColumn.vue";
// import PvBottomBar from "./common/PvBottomBar.vue";
import PvModals from "./common/PvModals.vue";
import moment from "moment";
import { alarmElimination } from "@/network/alarm-realtime";

export default {
  name: "PhotovoltaicScreen",
  components: {
    PvHeader,
    PvLeftColumn,
    PvCenterColumn,
    PvRightColumn,
    PvModals,
  },
  props: {
    /** 不传则用大屏内置标题（与原型一致） */
    screenTitle: {
      type: String,
      default: "河南联通（济源）分公司综合能源管控平台",
    },
  },
  data() {
    return {
      alarms: [],
      clearanceLog: [],
      headerOnlineSites: 0,
      alarmIdx: -1,
      clearanceModal: false,
      logModal: false,
      clearancePerson: "管理员",
      clearanceNote: "",
    };
  },
  computed: {
    currentAlarm() {
      if (
        this.alarmIdx < 0 ||
        this.alarmIdx >= this.alarms.length
      ) {
        return null;
      }
      return this.alarms[this.alarmIdx];
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResizeCharts, false);
    this.scheduleChartResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResizeCharts, false);
  },
  methods: {
    onResizeCharts() {
      this.scheduleChartResize();
    },
    scheduleChartResize() {
      setTimeout(() => {
        const c = this.$refs.centerColumn;
        if (c && c.resizeCenterCharts) c.resizeCenterCharts();
        const r = this.$refs.rightColumn;
        if (r && r.resizeGauge) r.resizeGauge();
      }, 120);
    },
    onSitesLoaded({ online }) {
      if (typeof online === "number" && online >= 0) {
        this.headerOnlineSites = online;
      }
    },
    openClearanceLog() {
      this.logModal = true;
    },
    showClearance(idx) {
      this.alarmIdx = idx;
      this.clearanceNote = "";
      this.clearanceModal = true;
    },
    closeClearance() {
      this.clearanceModal = false;
    },
    confirmClearance() {
      const person = (this.clearancePerson || "").trim();
      if (!person) {
        window.alert("请输入消警人");
        return;
      }
      const a = this.alarms[this.alarmIdx];
      if (!a) return;
      const note = (this.clearanceNote || "").trim() || "无备注";

      const finish = () => {
        this.closeClearance();
        const left = this.$refs.pvLeft;
        if (left && typeof left.reloadAfterClearance === "function") {
          left.reloadAfterClearance();
        }
      };

      const fail = (msg) => {
        if (this.$message) this.$message.error(msg || "消警失败");
        else window.alert(msg || "消警失败");
      };

      if (a.id == null || a.id === "") {
        fail("告警数据缺少 id，无法消警");
        return;
      }
      // 与 AlarmHandling.vue / App.vue 消警参数一致
      alarmElimination({
        id: a.id,
        operationTxt: note,
        operator: person,
      })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            if (this.$message) this.$message.success("消警成功");
            this.clearanceLog.unshift({
              station: a.station,
              msg: a.msg,
              person,
              note,
              clearedTime: moment().format("MM-DD HH:mm"),
            });
            finish();
          } else {
            fail(res && res.message);
          }
        })
        .catch(() => fail("请求失败"));
    },
  },
};
</script>

<style lang="scss">
@import "./common/pv-dashboard.scss";
</style>
